import {Component, Input, OnChanges} from '@angular/core';
import * as sanitizeHtml from 'sanitize-html';

import { Rule } from '../services/capd.model';

@Component({
  selector: 'company-fd-message-editor',
  templateUrl: './company-fd-message-editor.component.html',
  inputs: ['rule'],
  styleUrls: ['./company-fd-message-editor.component.less']
})

/**
 * Component for editing a default (Fluency Direct/HCC) message card.
 */
export class CompanyFdMessageEditorComponent implements OnChanges {
  @Input() rule: Rule;
  single: string;
  double: string;
  messageText: string;

  ngOnInit() {
    this.rule.action.messageText = sanitizeHtml(this.rule.action.messageText);

    // Disable the alert function on this window to avoid any triggering of undesired modals
    window.alert = function() {};
  }


  /**
   * Whenever you change the rule, if the message editor is loaded, turn the options into a comma-separated list.
   *
   * @func ngOnChanges
   */
  ngOnChanges(){
    switch (this.rule.action.actionSubtype) {
      case 'Radio':
      case 'Dropdown':
        if (!!this.rule.action.groups){this.single = this.rule.action.groups[1].options.join(','); }
        else{this.single = ''; }
        break;
      case 'DropdownStack':
        if (!!this.rule.action.groups){this.single = this.rule.action.groups[1].options.join(','); }
        else{this.single = ''; }
        if (!!this.rule.action.groups){this.double = this.rule.action.groups[2].options.join(',') ; }
        else{this.single = ''; }
        break;
      case 'RadioInline':
      case 'DropdownInline':
        if (!!this.rule.action.groups){this.single = this.rule.action.groups[1].options.join(','); }
        else{this.single = ''; }
        if (!!this.rule.action.groups){this.double = this.rule.action.groups[3].options.join(',') ; }
        else{this.single = ''; }
        break;
      default:
        this.single = '';
        this.double = '';
        break;
    }
  }

  /**
   * Converts a list of comma-separated options into an array for display.
   *
   * @func convertToGroup
   * @param {string} data  - the unprocessed string.
   * @param {string} type  - the type of the particular action group.  If it's text, it needs no processing.
   * @param {number} index - the index of the group being edited.
   */
  convertToGroup(data: string, type: string, index: number) {
    if (type !== 'Text') {
      const dataConvert = data.split(',');
      this.rule.action.groups[index] = {type, messageText: null, options: dataConvert};
    }
    else {
      this.rule.action.groups[index] = {type, messageText: sanitizeHtml(data), options: null};
    }
  }

  sanitizeHtml(inputText) {
    return sanitizeHtml(inputText,  {
      allowedTags: [ 'b', 'i', 'em', 'strong', 'a', "aside", "footer", "header", "h1", "h2", "h3", "h4",
        "h5", "h6", "div", "caption", "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead",
        "tr", "li", "main", "ol", "p", "pre", "ul", "br", "u"],
      allowedAttributes: {
        'a': [ 'href', 'name', 'target' ]
      },
      disallowedTagsMode: 'discard',
      selfClosing: ['br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
      allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
      allowedSchemesByTag: {},
      allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
      allowProtocolRelative: true,
      enforceHtmlBoundary: false
    });
  }

  // Replace & " < > '
  encodeHTML(inputText) {
    return inputText.replace(/&/g,'&amp;')
        .replace(/"/i,'&quot;')
        .replace(/</i, '&lt;')
        .replace(/>/i,'&gt;')
        .replace(/'/i,'&apos;');
  }

  encodeImage(inputText) {
    return inputText.replace(/<img/i, '&lt;img')
        .replace(/<\/img>/i, '&lt;img&gt;');
  }

  encodeAlert(inputText) {
    return inputText.replace(/alert\(/i, ' ');
  }

  resetRule(rule) {
    this.rule = rule
  }

  replaceMessageText() {
    this.rule.action.messageText = document.querySelector(".ql-editor").innerHTML.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
  }

  replaceGroupedMessageText() {
    this.rule.action.groups[0].messageText = document.querySelector(".ql-editor").innerHTML.replaceAll("&lt;", "<").replaceAll("&gt;", ">");
  }

  setEditorText() {
    setTimeout(() => {
      try {
        if(this.rule.action.messageText) {
          this.messageText = this.rule.action.messageText;
        }
        else if(this.rule.action && this.rule.action.groups && this.rule.action.groups.length > 0 && this.rule.action.groups[0].messageText)
          this.messageText = this.rule.action.groups[0].messageText
      } catch (e) {
        // this is for when this.rule.action.groups[0].messageText has not yet been created
        console.log(e)
        this.messageText = ""
      }
    }, 1);
  }

}
